import BaseComponent from '../../../js/base-component';

class CareProduct extends BaseComponent {
    constructor(options) {
        super(options);

        // this.product = this.element.querySelector('.u-care-product') || '';

        // console.log( this.element);

        this.element.addEventListener("click", (e) => { this.element.querySelector('form').submit(); });
    }

    onInit() {}
}

export default {
    name: 'CareProduct',
    definition: CareProduct
};